//index.js
import React from 'react';
import ReactDOM from 'react-dom';
import App from 'App'
import { unregister } from 'registerServiceWorker';

ReactDOM.render(
    <App />,
    document.getElementById('root')
);

// Service worker removed: its cache-first precaching forced users to hard-refresh
// to see new deploys. unregister() also tears down any previously-installed worker.
unregister();